import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './modules/dashboard/components/dashboard/dashboard.component';
import { ProductsComponent } from './modules/products/components/products/products.component';
import { ConfigurationManagementComponent } from './modules/configurationmanagement/components/configuration.management.component';
import { ConfigurationManagementManageComponent } from './modules/configurationmanagement/components/manage/configuration.management.manage.component';
import { ConfigurationManagementListComponent } from './modules/configurationmanagement/components/list/configuration.management.list.component';
import { RoleClaimsComponent } from './modules/products/components/roleclaims/roleclaims.component';
import { ClaimsListComponent } from './modules/rolemanagement/components/list/claims/claims.list.component';
import { UsersListComponent } from './modules/usermanagement/list/user.list.component';
import { UserRoleManageComponent } from './modules/usermanagement/manage/userrole.manage.component';
import { LoginComponent } from './modules/login/components/login.component';
import { UnauhorizedComponent } from './modules/unauthorized/unauthorized.component';
import { AuthComponent } from './auth.component';
import { LayoutComponent } from './layout.component';
import { AuthGuard } from './services/auth.guard';
import { ConsumerListComponent } from './modules/consumer/components/list/consumer-list.component';
import { StationListComponent } from './modules/station/components/list/station-list.component';
import { TocListComponent } from './modules/trainoperationcompany/components/list/toc-list.component';
import { ResetPasswordComponent } from './modules/resetpassword/components/resetpassword.component';
import { VideoListComponent } from './modules/videos/components/list/video-list.component';
import { VideoAddEditComponent } from './modules/videos/components/add-edit/video-add-edit.component';

// sets up routes constant where you define your routes
const routes: Routes = [
    { 
      path: '', component: LayoutComponent,
      canActivate: [AuthGuard],
      children: [
        { path: '', component: DashboardComponent},
        { path: 'roles', component: ProductsComponent},
        { path: 'configuration', component: ConfigurationManagementComponent},
        { path: 'configurationdetails', component: ConfigurationManagementListComponent},
        { path: 'manageconfiguration', component: ConfigurationManagementManageComponent},
        { path: 'roleclaim', component: RoleClaimsComponent},
        { path: 'claims', component: ClaimsListComponent},
        { path: 'users', component: UsersListComponent},
        { path: 'userroles', component: UserRoleManageComponent},
        { path: 'unauthorized', component: UnauhorizedComponent},
        { path: 'consumers', component: ConsumerListComponent},
        { path: 'stations', component: StationListComponent},
        { path: 'toc', component: TocListComponent},
        { path: 'videos', component: VideoListComponent}
      ]
    },
    { 
      path: '', component: AuthComponent,
      children: [
        { path: 'login', component: LoginComponent},
        { path: 'resetpassword/:passwordtoken', component: ResetPasswordComponent}
      ]
    },
    { path: '**', redirectTo: 'unauthorized' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
